import React, { useEffect } from 'react';
import { useResidentData } from '../hooks/useResidentData';
import { LoadingBar } from '../../components/common/LoadingBar';
import '../../components/common/CRMForm.css';

const PropertyInfoSection: React.FC = () => {
  const { property, isLoading: globalLoading, loadingMessage, error, fetchProperty } = useResidentData();

  useEffect(() => {
    fetchProperty();
  }, [fetchProperty]);

  if (globalLoading) {
    return <LoadingBar isLoading={globalLoading} message={loadingMessage} />;
  }

  if (error) {
    return (
      <section className="form-section">
        <div className="form-section-content">
          <div className="app-error-message">Error: {error}</div>
        </div>
      </section>
    );
  }

  if (!property) {
    return (
      <section className="form-section">
        <div className="form-section-content">
          <div className="app-welcome-message">
            <p>Property information unavailable.</p>
          </div>
        </div>
      </section>
    );
  }

  // Check if address is verified (handling potential missing type definition or backend inconsistencies)
  const isAddressVerified = property.address && ((property.address as any).verified === true || (property.address as any).verified === 1);

  // Format address for display
  const formatAddressDisplay = () => {
    if (!property.address) return 'N/A';
    const parts = [];
    if (property.address.street1) {
      parts.push(property.address.street1 + (property.address.unit ? ` Unit ${property.address.unit}` : ''));
    }
    if (property.address.street2) {
      parts.push(property.address.street2);
    }
    if (property.address.city || property.address.state || property.address.zip) {
      const cityStateZip = [
        property.address.city,
        property.address.state,
        property.address.zip
      ].filter(Boolean).join(', ');
      parts.push(cityStateZip);
    }
    return parts.join('\n');
  };

  return (
    <section className="form-section">
      <h3>Property Information</h3>
      <div className="form-section-content">
        <div className="app-form-row">
          <div className="app-form-group">
            <label className="app-form-label">Property Name</label>
            <p className="app-form-display">{property.name || 'N/A'}</p>
          </div>
          <div className="app-form-group">
            <label className="app-form-label">Property Type</label>
            <p className="app-form-display">{property.categoryName || 'N/A'}</p>
          </div>
        </div>

        {property.address && (
          <div className="app-form-group">
            <label className="app-form-label">
              Address
              {isAddressVerified && (
                <span style={{ marginLeft: '0.5rem', color: '#22c55e' }} title="Address Verified">✓</span>
              )}
            </label>
            <p className="app-form-display" style={{ whiteSpace: 'pre-line' }}>{formatAddressDisplay()}</p>
          </div>
        )}

        {property.description && (
          <div className="app-form-group">
            <label className="app-form-label">Description</label>
            <p className="app-form-display">{property.description}</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default PropertyInfoSection;
